import { render, staticRenderFns } from "./generate-journal-report-form.vue?vue&type=template&id=12ba1fce&"
import script from "./generate-journal-report-form.vue?vue&type=script&lang=js&"
export * from "./generate-journal-report-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports